
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/oppna-skidorter",
      function () {
        return require("private-next-pages/[region]/oppna-skidorter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/oppna-skidorter"])
      });
    }
  